import { Checkbox } from '@consta/uikit/Checkbox'
import type { WellId } from 'common/types'
import type { FC } from 'react'

import css from './WellsTable.css'

type WellNameCell = {
  wellId: WellId
  wellName: string
  onCheck?: (wellId: WellId) => void
  chosen?: boolean
}

export const WellNameCell: FC<WellNameCell> = ({ wellId, wellName, chosen, onCheck }) => {
  const canChoose = onCheck != null

  const handleChange = () => {
    onCheck?.(wellId)
  }

  return (
    <span className={css.wellNameCell}>
      {!!canChoose && <Checkbox checked={chosen} onChange={handleChange} />} {wellName}
    </span>
  )
}
